import { Link, useParams } from "react-router-dom"
import { useT } from "../i18n/index.tsx"
import { CaseDetailView } from "../components/case-detail/CaseDetailView.tsx"
import { Icon } from "../ui/index.ts"

/**
 * 반품 상세 전체 화면(/cases/:id).
 *
 * 내용은 CaseDetailView 하나를 목록의 옆판과 함께 쓴다. 이 경로는 링크로 주고받거나
 * 새 탭으로 여는 용도로 남겨 둔다 — 목록에서 훑을 때는 옆판이 더 빠르다.
 */
export function CaseDetailPage() {
  const { id } = useParams()
  const t = useT()
  return (
    <>
      <Link to="/cases" className="back-link">
        <Icon name="chevronLeft" size={14} />
        {t("cases.title")}
      </Link>
      <CaseDetailView caseId={Number(id)} />
    </>
  )
}
